var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 56,
    viewBox: "0 0 44 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M33.222 17.629c0 13.029-16.224 27.493-16.224 27.493S.779 30.658.779 17.629C.779 8.378 8.038.877 16.998.877c8.963-.001 16.224 7.5 16.224 16.752z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "158.6%",
    height: "142.9%",
    x: "-29.3%",
    y: "-19.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#399CDB",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#61B0E2",
    d: "M36.732 21.741c0 11.941-14.733 25.199-14.733 25.199S7.27 33.682 7.27 21.741c0-8.479 6.592-15.354 14.729-15.354 8.14 0 14.733 6.875 14.733 15.354z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.998 10.004c6.096 0 11.037 4.962 11.037 11.084s-4.941 11.085-11.037 11.085c-6.094 0-11.034-4.963-11.034-11.085 0-6.121 4.94-11.084 11.034-11.084z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.e395865257bfc11480e27a7212b7170c.svg";
export { ForwardRef as ReactComponent };